export { default } from './TaggisQrLogo';



// WEBPACK FOOTER //
// ./src/components/atoms/TaggisQrLogo/index.js